import React, { useEffect, useState } from 'react'
import {
    BrowserRouter as Router,
    Switch,
    Route,
    NavLink
} from "react-router-dom";
import { Footer } from './Footer';
import { Perfil } from '../cliente/Perfil';
import { PlanDePagos } from '../cliente/PlanDePagos';
import { Progreso } from '../cliente/Progreso';
import { DatosPaquete } from '../cliente/DatosPaquete';
import { PagosHistorial } from '../cliente/PagosHistorial';
import { Pagar } from '../cliente/Pagar';
import { Crear } from '../cliente/habitacion/Crear';
import { useSelector, useDispatch } from 'react-redux';
import { Contrato } from '../cliente/contrato/Contrato';
import { startLogout } from '../../actions/auth';
import { Lista } from '../cliente/habitacion/Lista';
import { Mensaje } from '../cliente/habitacion/Mensaje';
import { initLoadPayments } from '../../actions/payments';
import { AvisoPrivacidad } from '../cliente/AvisoPrivacidad';
import { Eventos } from '../cliente/eventos/Eventos';
import { DesgloseExtras } from '../cliente/DesgloseExtras';
import PreCancelado from '../cliente/alerts/PreCanceldo';
import Redes from '../cliente/alerts/Redes';
import { Album } from '../cliente/fotos/Album';

const body = document.getElementsByTagName('body')[0];

export const BodyCliente = ({location}) => {

    const dispatch = useDispatch()
    const {nombre, ape_paterno, folio, correo, celular, habitaciones_id, bus, asiento, paquete, redes, status} = useSelector(state => state.client)
    const [darkMode, setDarkMode] = useState((localStorage.getItem('theme') === 'dark'));
    const [url, setUrl] = useState(location.pathname);

    // Historial Pagos
    const {list, total, loading} = useSelector(state => state.payments);
    const {costoPaquete} = useSelector(state => state.client);

    const porcentaje = total * 100 / costoPaquete;

    if(nombre){
        window.smartsupp('name', `${nombre} ${ape_paterno} - ${folio}`);
        window.smartsupp('email', correo);
        window.smartsupp('phone', celular);
        window.smartsupp('variables', {
            User_ID: folio
        });
    }

    const handleRefresh = () => {
        dispatch(initLoadPayments());
    }
    // Historial Pagos
    

    const handleDarkMode = (e) => {
        if(darkMode){
            localStorage.setItem('theme', 'light');
            body.classList.remove('dark-theme');
        } else{
            localStorage.setItem('theme', 'dark');
            body.classList.add('dark-theme');
        }
        setDarkMode(!darkMode);
    }

    const handleCompact = (e) => {
        e.preventDefault();
        if(!document.getElementsByTagName('body')[0].classList.contains('compact-sidebar'))
            document.getElementsByTagName('body')[0].classList.add('compact-sidebar');
        else
            document.getElementsByTagName('body')[0].classList.remove('compact-sidebar');
    }

    const handleSidebar = (e) => {
        e.preventDefault();
        if(!document.getElementsByTagName('body')[0].classList.contains('small-screen-sidebar-active'))
            document.getElementsByTagName('body')[0].classList.add('small-screen-sidebar-active');
        else
            document.getElementsByTagName('body')[0].classList.remove('small-screen-sidebar-active')
    }

    const handleLogOut = (e) => {
        e.preventDefault();
        dispatch(startLogout(true));
    }
    return (
        <Router>
           {status === 'Pre-Cancelado' && <PreCancelado />}
            <div className="connect-container align-content-stretch d-flex flex-wrap">
                <div className="page-sidebar" onClick={handleSidebar}>
                    <div className="logo-box">
                        <div className="d-inline-block w-75">
                            <img 
                                src={
                                    (localStorage.getItem('theme') === 'dark')
                                        ? '/assets/images/logo-white.png'
                                        : '/assets/images/logo-black.png'
                                }
                                alt="Skyfest"
                            />
                        </div>
                        <a href="/" id="sidebar-close" onClick={handleCompact}><i className="material-icons">close</i></a>
                        <a href="/" id="sidebar-state" onClick={handleCompact}>
                            <i className="material-icons">adjust</i>
                            <i className="material-icons compact-sidebar-icon">panorama_fish_eye</i>
                        </a>
                    </div>
                    <div className="page-sidebar-inner slimscroll">
                        <ul className="accordion-menu">
                            {/* <li className="sidebar-title">
                                Apps
                            </li> */}
                            <li className={`${url === '/' && 'active-page'}`} >
                                <NavLink exact to="/" onClick={() => setUrl('/')}>
                                    <i className="material-icons-outlined">dashboard</i>Inicio
                                </NavLink>
                            </li>
                            <li className={`${url === '/pagos' && 'active-page'}`} >
                                <NavLink to="/pagos" onClick={() => setUrl('/pagos')}>
                                    <i className="material-icons-outlined">account_balance_wallet</i>Pagos
                                </NavLink>
                            </li>
                            <li className={`${url === '/contrato' && 'active-page'}`} >
                                <NavLink to="/contrato" onClick={() => setUrl('/contrato')}>
                                    <i className="material-icons-outlined">admin_panel_settings</i>Contrato
                                </NavLink>
                            </li>
                            {paquete.habitaciones == true 
                            ? <li className={`${url === '/habitacion' && 'active-page'}`} >
                                <NavLink to="/habitacion" onClick={() => setUrl('/habitacion')}>
                                    <i className="material-icons-outlined">hotel</i>Habitación
                                </NavLink>
                            </li>
                            : habitaciones_id != null && <li className={`${url === '/habitacion' && 'active-page'}`} >
                                <NavLink to="/habitacion" onClick={() => setUrl('/habitacion')}>
                                    <i className="material-icons-outlined">hotel</i>Habitación
                                </NavLink>
                            </li>
                            }
                            {/* <li className={`${url === '/eventos' && 'active-page'}`} >
                                <NavLink to="/eventos" onClick={() => setUrl('/eventos')}>
                                    <i className="material-icons-outlined">celebration</i>Eventos
                                </NavLink>
                            </li> */}
                            {/* <li className={`${url === '/privacidad' && 'active-page'}`} >
                                <NavLink to="/privacidad" onClick={() => setUrl('/privacidad')}>
                                <i className="material-icons-outlined">privacy_tip</i>Aviso de Privacidad
                                </NavLink>
                            </li> */}
                            {
                                paquete.anio === '2023' && paquete.calendario === 'Verano' &&
                                <li className={`${url === '/album' && 'active-page'}`} >
                                    <NavLink to="/album" onClick={() => setUrl('/album')}>
                                        <i className="material-icons-outlined">photo_library</i>Album de Fotos
                                    </NavLink>
                                </li>
                            }
                        </ul>
                    </div>
                </div>
                <div className="page-container">
                    <div className="page-header">
                        <nav className="navbar navbar-expand">
                            <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarNav" aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
                                <span className="navbar-toggler-icon"></span>
                            </button>
                            <ul className="navbar-nav d-flex w-100">
                                <li className="nav-item small-screens-sidebar-link">
                                    <a href="/" className="nav-link" onClick={handleSidebar}><i className="material-icons-outlined">menu</i></a>
                                </li>

                                <li className="nav-item nav-profile dropdown" style={{marginLeft: 'auto'}}>
                                    <a className="nav-link dropdown-toggle" href="./" id="navbarDropdown" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                        <img src="/assets/images/perfil-default.jpg" alt="profileImage" />
                                        <span>{nombre}</span><i className="material-icons dropdown-icon">keyboard_arrow_down</i>
                                    </a>
                                    <div className="dropdown-menu dropdown-menu-right" aria-labelledby="navbarDropdown" style={{right: 0}}>
                                        <div className="custom-control custom-switch ml-4">
                                            <input 
                                                type="checkbox" 
                                                className="custom-control-input" 
                                                id="customSwitch1" 
                                                checked={darkMode} 
                                                onChange={handleDarkMode} 
                                            />
                                            <label className="custom-control-label" htmlFor="customSwitch1" style={{color: '#6c6e7a'}}><i className="far fa-moon"></i> Dark mode</label>
                                        </div>
                                        <div className="dropdown-divider"></div>
                                        <a className="dropdown-item" href="/" onClick={ handleLogOut }>Cerrar Sesión</a>
                                    </div>
                                </li>
                            </ul>
                        </nav>
                    </div>
                    <div className="page-content">
                        <div className="main-wrapper">
                        <Switch>
                            <Route path="/pagos">
                                <div className="row">
                                    <div className="col-lg">
                                        <Pagar />
                                    </div>
                                    <div className="col-lg">
                                        <div className="card">
                                            <PagosHistorial 
                                                list={list}
                                                total={total}
                                                loading={loading}
                                                costoPaquete={costoPaquete}
                                                refresh={handleRefresh}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </Route>
                            <Route path="/contrato" component={Contrato}/>
                            <Route path="/privacidad" component={AvisoPrivacidad}/>
                            <Route path="/eventos" component={Eventos}/>
                            {
                                paquete.anio === '2023' && paquete.calendario === 'Verano' &&
                                <Route path="/album" component={Album}/>
                            }
                            
                            <Route path="/habitacion">
                                {
                                    !habitaciones_id
                                        ?<Crear />
                                        :<Lista />

                                }
                            </Route>
                            <Route path="/">
                                <div className="row">
                                    <div className="col">
                                    {
                                        !habitaciones_id
                                            && <Mensaje setUrl={setUrl} />

                                    }
                                    {
                                        !!bus && !!asiento && porcentaje >= 99.9 
                                        ?<div className="row">
                                            <div className="col-md-6 mb-4 d-sm-none d-md-block">
                                                <div className="d-none d-md-block">
                                                    <a 
                                                        class="btn btn-primary btn-block animate__animated animate__heartBeat"
                                                        target="_blank"
                                                        rel="noopener noreferrer"
                                                        href={`${process.env.REACT_APP_API_URL}/pdf/travelpass/${localStorage.getItem('token')}`}
                                                    > <i className="fas fa-arrow-circle-down"></i> Descargar TravelPass</a>
                                                </div>
                                                <div className="d-block d-md-none alert alert-warning">
                                                    Tu TravelPass esta listo, pero solo se puede descargar desde una computadora.
                                                </div>
                                            </div>
                                            <div className="col-md-6  mb-4">
                                                <a 
                                                    class="btn btn-success btn-block animate__animated animate__heartBeat"
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                    href={`${process.env.REACT_APP_API_URL}/assets/pdf/itinerario/${bus}.pdf`}
                                                > <i className="fas fa-arrow-circle-down"></i> Descargar Itinerario</a>
                                            </div>
                                        </div>
                                        : porcentaje >= 99.9 &&
                                            <div className="row">
                                            <div className="col">
                                                <div class="alert alert-success" role="alert">
                                                    <h4 class="alert-heading">¡Felicidades!</h4>
                                                    {/* <p>Aww yeah, you successfully read this important alert message. This example text is going to run a bit longer so that you can see how spacing within an alert works with this kind of content.</p>
                                                    <hr />
                                                    <p class="mb-0">Whenever you need to, be sure to use margin utilities to keep things nice and tidy.</p> */}
                                                </div>
                                            </div>
                                    </div>
                                    }
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col">
                                        {redes !== '1' && <Redes />}
                                        <Perfil />
                                        {/* <DatosPaquete /> */}
                                        <DesgloseExtras />
                                    </div>
                                    <div className="col">
                                        <Progreso />
                                        <PlanDePagos />
                                    </div>
                                </div>
                            </Route>
                        </Switch>
                        </div>
                    </div>
                    <Footer />
                </div>
            </div>
        </Router>
    )
}
